module.exports = "/images/vendor/primevue/resources/color.png?6441e63a57ccc5105bad045142bc31eb";